<template>
       <tw-card :class="[$page.props.settings.site_name == 'Zilliqa' ? 'bg-black' : 'bg-gray-800', 'grid grid-cols-3 transition dark:text-white items-center overflow-y: scroll;']" height="text-white p-0 h-full" :center-text="true">

            <template #filter>
                <!-- <div >
                    <jet-date-picker id="date" v-show="$page.props.settings.site_name !== 'Racing League' || user.is_admin" as-single v-model="dateModel" placeholder="Select Date" :formatter="format"/>
                </div> -->
            </template>

           <template #filter2 >
                <Popper placement="bottom" arrow="true" :show="(user.tutorial_step === 2)">
                    <Listbox as="div" :disabled="user.tutorial_step"
                             class="relative flex text-white items-center lg:items-end col-start-3 justify-end flex-col"
                    >
                        <ListboxButton class="flex flex-col lg:flex-row hover:bg-gray-700 rounded-md"
                                       v-if="$page.props.features.remove_countries === false"
                        >
                            <p v-if="meetingsSelection === 'GB'" class="hidden lg:flex my-auto mx-2 font-semibold text-gray-300 text-xs lg:text-sm p-1 order-last lg:order-first">United Kingdom</p>
                            <p v-if="meetingsSelection === 'GB'" class="lg:hidden my-auto mx-2 font-semibold text-gray-300 text-xs lg:text-sm p-1 order-last lg:order-first">UK</p>
                            <p v-if="meetingsSelection === 'IRE'" class="hidden lg:flex my-auto mx-2 font-semibold text-gray-300 text-xs lg:text-sm p-1 order-last lg:order-first">Ireland</p>
                            <p v-if="meetingsSelection === 'IRE'" class="lg:hidden my-auto mx-2 font-semibold text-gray-300 text-xs lg:text-sm p-1 order-last lg:order-first">IRE</p>
                            <p v-if="meetingsSelection === 'UAE'" class="hidden lg:flex my-auto mx-2 font-semibold text-gray-300 text-xs lg:text-sm p-1 order-last lg:order-first">United Arab Emirates</p>
                            <p v-if="meetingsSelection === 'UAE'" class="lg:hidden my-auto mx-2 font-semibold text-gray-300 text-xs lg:text-sm p-1 order-last lg:order-first">UAE</p>
                             <p v-if="meetingsSelection === 'USA'" class="hidden lg:flex my-auto mx-2 font-semibold text-gray-300 text-xs lg:text-sm p-1 order-last lg:order-first">United States</p> 
                             <p v-if="meetingsSelection === 'USA'" class="lg:hidden my-auto mx-2 font-semibold text-gray-300 text-xs lg:text-sm p-1 order-last lg:order-first">USA</p> 
                            <span class="block px-0 py-1.5 bg-cover bg-center bg-no-repeat w-[2.8rem] h-[2.8rem] rounded-full mx-auto border-2 border-gray-400" :class="[meetingsSelection === 'GB' ? 'bg-uk' : '', meetingsSelection === 'IRE' ? 'bg-ire' : '', meetingsSelection === 'UAE' ? 'bg-uae' : '', meetingsSelection === 'USA' ? 'bg-usa' : '']"></span>
                        </ListboxButton>


                        <ListboxOptions class="absolute top-16 bg-gray-900 p-2 border-2 border-gray-600 rounded-md z-20">
                            <ListboxOption as="div" @click="activeCountry('GB')" class="flex text-center my-2 cursor-pointer hover:bg-gray-700 rounded-md" :class="[meetingsSelection === 'GB' ? 'hidden':'']">
                                <p class="my-auto mx-auto p-2 hidden lg:flex">United Kingdom</p>
                                <button class="block px-0 py-1.5 bg-gray-500 bg-cover bg-center bg-no-repeat w-[3.2rem] h-[3.2rem] rounded-full mx-auto lg:mx-1 bg-uk"
                                        :class="[meetingsSelection === 'GB' ? 'border-racing-stars-yellow border-2 border-in':'border-gray-600','border']">
                                        <p class="lg:hidden">UK</p>
                                </button>
                            </ListboxOption>
                            <ListboxOption as="div" @click="activeCountry('IRE')" class="my-2 flex cursor-pointer hover:bg-gray-700 rounded-md" :class="[meetingsSelection === 'IRE' ? 'hidden':'']">
                                <p class="my-auto mx-auto p-2 hidden lg:flex">Ireland</p>
                                <button
                                    @click="activeCountry('IRE')" class="block px-0 py-2 bg-gray-500 bg-cover bg-center bg-no-repeat w-[3.2rem] h-[3.2rem] rounded-full mx-auto lg:mx-1 bg-ire"
                                    :class="[meetingsSelection === 'IRE' ? 'border-racing-stars-yellow border-2':'border-gray-600',tutorialStep>0 ? 'opacity-50': 'opacity-100', 'border']">
                                    <p class="lg:hidden">IRE</p>
                                </button>
                            </ListboxOption>
                            <ListboxOption as="div" @click="activeCountry('UAE')" class="my-2 flex cursor-pointer hover:bg-gray-700 rounded-md" :class="[meetingsSelection === 'UAE' ? 'hidden':'']">
                                <p class="my-auto mx-auto p-2 hidden lg:flex">United Arab Emirates</p>
                                <button
                                    @click="activeCountry('UAE')"
                                    class="block px-0 py-1.5 bg-gray-500 bg-cover bg-center bg-no-repeat w-[3.2rem] h-[3.2rem] rounded-full mx-auto lg:mx-1 bg-uae"
                                    :class="[meetingsSelection === 'UAE' ? 'border-racing-stars-yellow border-2':'border-gray-600',tutorialStep>0 ? 'opacity-50': 'opacity-100', 'border']">
                                    <p class="lg:hidden">UAE</p>
                                </button>
                            </ListboxOption>
                             <ListboxOption as="div" @click="activeCountry('USA')" class="my-2 flex cursor-pointer hover:bg-gray-700 rounded-md" :class="[meetingsSelection === 'USA' ? 'hidden':'']"> 
                                 <p class="my-auto mx-auto p-2 hidden lg:flex">United States</p> 
                                 <button 
                                     @click="activeCountry('USA')" 
                                     class="block px-0 py-1.5 bg-gray-500 bg-cover bg-center bg-no-repeat w-[3.2rem] h-[3.2rem] rounded-full mx-auto lg:mx-1 bg-usa" 
                                     :class="[meetingsSelection === 'USA' ? 'border-racing-stars-yellow border-2':'border-gray-600',tutorialStep>0 ? 'opacity-50': 'opacity-100', 'border']" 
                                     :disabled="(tutorialStep > 0)"> 
                                     <p class="lg:hidden">USA</p> 
                                 </button> 
                             </ListboxOption> 
                        </ListboxOptions>
                    </Listbox>

                    <template #content>
                        <StepTwoCard :meeting="meeting" :tutorialStep="user.tutorial_step" @update="setTutorialStep($event);"/>
                    </template>                <p>Bruh moment</p>
                </Popper>

            </template>

            <div class="grid grid-cols-3 w-full justify-between">
                <jet-date-picker id="date" class="w-12" as-single v-model="dateModel" placeholder="Select Date" :formatter="format"/>
                <h class="text-2xl font-medium m-auto">Dashboard</h>
            </div>

            <div v-if="processing" class="flex justify-center mt-4 mb-4 sm:mt-0 sm:mt-0">
                <span class="text-gray-900 bg-racing-stars-yellow font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 inline-flex items-center">
                    <svg role="status" class="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#000001"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                    </svg>
                    Loading...
                </span>
            </div>

                <div v-else-if="meetings.length">
                    <new-meetings-accordion v-if="$page.props.features.new_meetings_accordion == true" :user="user" :banners="banners" v-bind:meetingsSelection='meetingsSelection' :meetings="meetings" :bets="bets" :tutorialStep="user.tutorial_step" @updateTutorialStep="setTutorialStep($event);"/>
                    <meetings-accordion v-else :user="user" v-bind:meetingsSelection='meetingsSelection' :meetings="meetings" :bets="bets" :tutorialStep="user.tutorial_step" @updateTutorialStep="setTutorialStep($event);"/>
                </div>

            <div v-else>
                No Meetings for Your Date Selection.
            </div>

        </tw-card>
</template>

<script>
import { ref, reactive, onMounted, watch, computed } from 'vue'
import moment from 'moment'
import TwCard from '@/Global/Elements/TwCard.vue'
import MeetingsAccordion from '@/Global/Play/Partials/MeetingsAccordion.vue'
import NewMeetingsAccordion from '@/Global/Play/Partials/NewMeetingsAccordion.vue'
import JetDatePicker from '@/Jetstream/DatePicker.vue'
import Popper from 'vue3-popper'
import TwModal from '@/Global/Elements/TwModal.vue'
import StepOneCard from './Partials/tutorials/StepOneCard.vue'
import StepTwoCard from './Partials/tutorials/StepTwoCard.vue'
import StepFinal from './Partials/tutorials/StepFinal.vue'
import { PencilIcon, ShoppingCartIcon, LightningBoltIcon, UserAddIcon, UserGroupIcon} from '@heroicons/vue/outline'
import { Menu,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    Dialog,
    DialogPanel,
    DialogTitle,
    DialogDescription
} from '@headlessui/vue'

export default {
    props: {
        user: {
            type: Object,
            default: {}
        },
    },
    components: {
        TwCard,
        TwModal,
        MeetingsAccordion,
        NewMeetingsAccordion,
        JetDatePicker,
        Popper,
        StepOneCard,
        StepTwoCard,
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        PencilIcon,
        ShoppingCartIcon,
        LightningBoltIcon,
        UserAddIcon,
        UserGroupIcon
    },

    setup(props) {
        const windowWidth = ref(window.innerWidth)
        const meetings = reactive([])
        const bets = ref([])
        const processing = ref(true)
        const isOpen = ref(false)
        const banners = ref([]);

        // function setIsOpen(value) {
        //     isOpen.value = value
        // }

    //    function checkLocalStorage() {
    //         let shownPopup = localStorage.getItem("welcomeBackShown")
    //         console.log(shownPopup)

    //         if (!localStorage.getItem("welcomeBackShown")) {
    //             setIsOpen(true)
    //             localStorage.setItem("welcomeBackShown", true)
    //         }
    //         console.log(shownPopup)
    //     }

        // Get todays date withouth time.
        const dateModel = ref(new Date().toLocaleDateString('en-GB'));

        // const dateModel = ref(new Date((new Date()).valueOf() + 1000*3600*24).toLocaleDateString('en-GB'))
        // const dateModel = ref(
        //     props.user.tutorial_step > 0 ?
        //         new Date((new Date()).valueOf() + 1000*3600*24).toLocaleDateString('en-GB'):
        //     (window.location.href.indexOf('racingleague') > -1 || window.location.href.indexOf('rl') > -1) ?
        //         '13/09/2023':
        //         new Date().toLocaleDateString('en-GB'))

        //         // window.location.href.indexOf('shark') > -1

        const format = ref({
            date: 'DD/MM/YYYY',
            month: 'MMM'
        })

        const getLocation = () => {
            return window.location.hostname;
        }

        const setDateModel = (date) => {
            date.setDate(date.getDate() + 1)

            dateModel.value = date.toLocaleDateString('en-GB')
        }

        const isMobile = computed(() => {
            return windowWidth.value < 640
        })

        const setWindowWidth = () => {
            windowWidth.value = window.innerWidth
        }

        const dDate = computed(() => {
            let splitDate = dateModel.value.split('/');
            let month = splitDate[1] - 1;
            let modelDate = new Date(splitDate[2], month, splitDate[0])

            return modelDate > new Date()

        })

        const getBets = () => {
            axios.get(route('api.bets.index'), {
                params: {
                    user_id: props.user.id
                }
            }).then(response => {
                bets.value = response.data
            })
        }

        const getMeetings = () => {
            processing.value = true

            axios.get(route('api.meetings.index'), {
                params: {
                    date: dateModel.value
                }
            }).then(response => {
                meetings.splice(0)

                if (response.data.meetings.length) {
                    Object.assign(meetings, response.data.meetings)
                }

                if (response.data.banners.length) {
                    banners.value = response.data.banners;
                }
                console.log(response.data);
                processing.value = false
            })
        }

        onMounted(() => {
            getBets()
            getMeetings()
            // checkLocalStorage()

            setWindowWidth()

            window.addEventListener('resize', setWindowWidth)

            Echo.private('notifications.' + props.user.id)
                .listen('BetPlaced', (e) => {
                    getBets()
                    getMeetings()
                })
        })

        watch(dateModel, (currentValue, oldValue) => {
            getMeetings()
        })

        return {
            moment,
            meetings,
            dateModel,
            format,
            setDateModel,
            dDate,
            bets,
            processing,
            isMobile,
            getLocation,
            banners
        }
    },
    data() {
        return {
            meetingsSelection: this.getStoredCountryCode(),
            randomIndex: 1,
        };
    },
    created() {
    // Generate a random index between 1 and meetings.length - 1 after the component is created
    this.randomIndex = Math.floor(Math.random() * (this.meetings.length - 1)) + 1;
  },

    methods: {
        getStoredCountryCode() {

            let storedCountryCode = localStorage.getItem('countryCode')

            if (storedCountryCode) {
                return storedCountryCode
            }

            return 'GB'
        },

        activeCountry(countryCode){
            this.meetingsSelection = countryCode

            // Store value of previously selected countryCode in cookies to continue on page later
            localStorage.setItem('countryCode', countryCode)
        },

    }
}

</script>
